export default "__VITE_ASSET__aa0145b6__"